"use strict";

var _interopRequireDefault = require("/var/www/html/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _typeof = require("/var/www/html/node_modules/@babel/runtime/helpers/typeof.js");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/var/www/html/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var XLSX = _interopRequireWildcard(require("xlsx/xlsx.mjs"));
var _pattern = require("@/api/pattern");
var _sceneManage = _interopRequireDefault(require("./components/scene-manage"));
var _lodash = _interopRequireDefault(require("lodash"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    SceneManage: _sceneManage.default
  },
  data: function data() {
    return {
      tableData: [],
      totalPage: 1,
      currentPage: 1,
      perPage: 15,
      totalNumber: 0,
      // 总数量
      scene: '',
      status: '',
      loading: true,
      statusList: [{
        value: '可用',
        label: 0
      }, {
        value: '禁用',
        label: 1
      }],
      chooseData: {}
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      var params = {
        page: this.currentPage,
        per_page: this.perPage
      };
      if (this.scene) {
        params.scene_id = this.scene;
      }
      if (this.status === 0 || this.status === 1) {
        params.status = this.status;
      }
      (0, _pattern.getSceneList)(params).then(function (_ref) {
        var code = _ref.code,
          data = _ref.data;
        _this.loading = false;
        if (code === 200) {
          var list = data.list,
            meta = data.meta;
          _this.tableData = list;
          _this.totalPage = meta.page.total_page;
          _this.totalNumber = meta.page.total;
        }
      }).catch(function (err) {
        _this.loading = false;
      });
    },
    onSearch: function onSearch() {
      this.loading = true;
      // 搜索重置
      this.totalPage = 1;
      this.currentPage = 1;
      this.getList();
    },
    onExport: function () {
      var _onExport = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var list, params, res, tableData, wb, ws;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              list = [];
              params = {
                page: 1,
                per_page: 100 // 需要拿到全部数据，先默认100
              };
              _context.next = 4;
              return (0, _pattern.getSceneList)(params);
            case 4:
              res = _context.sent;
              if (res.code === 200 && res.data.list) {
                list = res.data.list;
              }
              tableData = list.map(function (row, index) {
                return {
                  场景ID: row.id,
                  状态: row.status === 0 ? '可用' : '禁用',
                  产品ID: row.product_id,
                  渠道号: row.channel_id,
                  创建时间: row.created_at,
                  有效时间: row.expired_at
                };
              });
              wb = XLSX.utils.book_new();
              ws = XLSX.utils.json_to_sheet(tableData);
              XLSX.utils.book_append_sheet(wb, ws, 'sheet1');
              XLSX.writeFile(wb, "\u6743\u91CD\u5206\u53D1\u914D\u7F6E_\u573A\u666F\u7801\u5217\u8868_".concat(Date.now(), ".xlsx"));
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function onExport() {
        return _onExport.apply(this, arguments);
      }
      return onExport;
    }(),
    // 分页
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.loading = true;
      this.getList();
    },
    onModify: function onModify(val) {
      this.$refs.managePop.dialogVisible = true;
      this.chooseData = _lodash.default.cloneDeep(val);
    },
    getHeaderCellStyle: function getHeaderCellStyle() {
      return {
        backgroundColor: '#f8faff'
      };
    }
  }
};